import{Button as xt,InlineMessage as yt,Input as Lt,Row as wt}from"@appcues/sonar";import{useForm as At}from"react-hook-form";import{Button as ft,Form as vt,InlineMessage as ht,Input as kt}from"@appcues/sonar";import It,{css as bt}from"styled-components";var Nt=bt`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`,Re=It(vt)`
  padding: var(--spacing-regular);
  padding-bottom: 0;

  ${ft} {
    flex: 1;
  }

  ${kt} {
    flex: 2;
    ${Nt};
  }

  ${ht} {
    padding-top: var(--spacing-small);
  }
`;import{jsx as de,jsxs as Ee}from"react/jsx-runtime";var D=({user:e,isSpoofing:t,onSpoof:i})=>{let{register:n,handleSubmit:a,formState:{errors:s,isSubmitting:r},setError:c}=At(),{isAdmin:m}=e!=null?e:{};return!m||t?null:Ee(Re,{onSubmit:a(async({accountId:p})=>{try{await i(p)}catch(h){c("accountId",{message:"Failed to spoof"})}}),children:[Ee(wt,{xAlign:"center",spacing:"small",children:[de(Lt,{id:"accountId",placeholder:"Account ID",type:"number",...n("accountId",{required:"Can't be empty"})}),de(xt,{type:"submit",disabled:r,children:"Spoof"})]}),s.accountId&&de(yt,{variant:"error",children:s.accountId.message})]})};import Be from"styled-components";var Fe=Be.header`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
  padding-top: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
`,We=Be.span`
  align-items: center;
  color: var(--color-blurple-600);
  display: flex;
  font-size: var(--icon-size-large);
  justify-content: center;

  svg {
    height: 30px;
    width: 24px;

    path {
      fill: currentColor;
    }
  }
`;import{jsx as $}from"react/jsx-runtime";var O=({size:e="regular"})=>$(Fe,{$size:e,children:$("a",{href:"/",children:$(We,{children:$("svg",{viewBox:"0 0 1600 2000",xmlns:"http://www.w3.org/2000/svg",role:"img","aria-label":"Appcues logo",children:$("path",{d:"M695.6 1083.4l555.9 870.5c14.1 21.2 35.3 31 60.7 31h206c39.5 0 70.5-31 70.5-70.5V70.4c0-66.3-83.2-95.9-127-43.7L695.6 998.8c-16.9 22.6-16.9 57.8 0 84.6zM70.6 1985h366.8c39.5 0 70.5-31 70.5-70.5V1446c0-66.3-83.2-95.9-127-43.7L14.1 1870.7c-35.2 48 0 114.3 56.5 114.3z"})})})})});import H from"styled-components";import{Stack as St}from"@appcues/sonar";var De=H(St).attrs({spacing:"none"})`
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  width: 240px;
  background-color: var(--color-neutral-0);
  border-right: 1px solid var(--border-default);
  display: flex;
  flex-direction: column;
  /*
  * This z-index is chosen because it is bigger than the biggest z-index currently
  * found in studio excluding Modals, which is in the studio classic TabsRoot
  * component (z-index: 3000). We will look at standardizing our use of z-index in
  * studio in the future.
  */
  z-index: 4000;
`,$e=H.div`
  overflow-y: auto;
  flex-grow: 1;
`,Oe=H.nav`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`,He=H.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
  padding-bottom: var(--spacing-small);
  padding-top: var(--spacing-small);
  list-style-type: none;
`,Y=H.div`
  width: 18px;
  height: 14px;
`;import{Icon as Tt,Row as Pt,Text as Ct}from"@appcues/sonar";import ze from"styled-components";import{Text as Ue}from"@appcues/sonar";var J=ze.li`
  a {
    height: 40px;
    display: flex;
    text-decoration: none;
    padding-left: var(--spacing-large);
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }
    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${Ue} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,Ge=ze.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${Ue} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as Z,jsxs as Mt}from"react/jsx-runtime";var _e=({children:e,icon:t,iconElement:i,NavLink:n,to:a,end:s,isActive:r,className:c,external:m=!1,isSubItem:d=!1,...p})=>Z(J,{className:c,children:Z(m||!n?"a":n,{isSubItem:d,to:a,end:s,className:r?"active":"",...p,children:Mt(Pt,{spacing:"small",yAlign:"center",children:[i&&i,t&&Z(Tt,{icon:t,colorToken:"foreground-secondary",size:"small"}),Z(Ct,{colorToken:"foreground-primary",children:e})]})})});import{useState as Wt}from"react";import{Accordion as Dt,Row as $t}from"@appcues/sonar";import{Accordion as j,Icon as Ft}from"@appcues/sonar";import z,{css as Ye}from"styled-components";import ue,{css as Rt}from"styled-components";import{Row as Et,Text as Ve}from"@appcues/sonar";var Bt=Rt`
  padding: 0 var(--spacing-regular);
`,Q=ue.div`
  a {
    height: ${({variant:e="regular"})=>e==="regular"?"40px":"64px"};
    display: flex;
    text-decoration: none;
    padding: 0 var(--spacing-large);
    ${({isSubItem:e})=>e&&Bt}
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }

    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${Ve} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,Ke=ue(Et)`
  max-width: 100%;
`,qe=ue(Ve).attrs({forwardedAs:"span"})`
  flex: 1;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;var fe=Ye`
  fill: var(--color-blurple-600);
`,ve=z(Ft)`
  display: block;
  // 18px is used so that the accordion icon aligns with the other nav item icons
  width: 18px;

  path {
    transition: fill 0.3s ease;
    // The active state is determined programatically because when the accordion is closed the active list item is reomved from the DOM
    ${({$isActive:e})=>e&&fe}
  }
`,Xe=Ye`
  background-color: var(--color-neutral-50);
  border-radius: var(--border-radius-small);
`,Je=z(j.Header)`
  height: 40px;
  display: flex;
  // The Sonar Accordion.Header has some padding that we need to override so that the correct hover background can be applied
  padding: 0;
  font-weight: var(--font-weight-regular);
  transition: background-color 0.3s ease;

  :hover {
    ${Xe};

    ${ve} {
      path {
        ${fe};
      }
    }
  }

  /* Shows accordion header as active if collapsed */
  &[data-state='closed'] {
    ${({$isActive:e})=>e&&Xe};
  }
`,Ze=z(j.Trigger)`
  color: var(--foreground-primary);
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
`,Qe=z(j.Content)`
  p {
    // Padding of 26px is required so that the accordion content aligns correctly with the other nav item text
    padding-left: 26px;
  }

  // We don't want padding on the last list item because a 4px space is already provided by the flex gap
  li {
    &:not(:last-child) {
      padding-bottom: var(--spacing-x-small);
    }
  }
`,je=z(j.Item)`
  // These styles create a gap between the trigger and the content when the accordion is expanded, but
  // the gap is removed when the accordion is collapsed
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);

  // This selector is used to apply the blurple fill to the accordion icon when one of it's children is hovered
  &:has(div > li > a:hover) {
    div > svg > path {
      ${fe}
    }
  }

  ${Q} {
    margin-left: var(--spacing-x-large);
    margin-right: var(--spacing-small);
    position: relative;
    &::before {
      content: '';
      display: block;
      width: 1px;
      height: 100%;
      background-color: var(--color-neutral-300);
      position: absolute;
      left: 0;
      top: 0;
    }
  }
`;import{jsx as U,jsxs as oo}from"react/jsx-runtime";var Ot="@navigation/accordion_",eo={getAccordionKey(e){return`${Ot}${e}`},getAccordionValue(e){let t=this.getAccordionKey(e);return localStorage.getItem(t)},setAccordionValue(e,t){let i=this.getAccordionKey(e);Boolean(t)?localStorage.setItem(i,t):localStorage.removeItem(i)}},to=({children:e,text:t,icon:i,isActive:n})=>{let a=()=>{if(n)return t;let m=eo.getAccordionValue(t);if(m)return m},[s,r]=Wt(a()),c=m=>{r(m),eo.setAccordionValue(t,m)};return U(Dt.Root,{collapsible:!0,value:s,onValueChange:c,type:"single",$unstyled:!0,children:oo(je,{value:t,children:[U(Je,{$isActive:n,children:U(Ze,{children:oo($t,{spacing:"small",yAlign:"center",children:[U(ve,{icon:i,colorToken:"color-neutral-700",size:"small",$isActive:n}),t]})})}),U(Qe,{children:e})]})})};import{jsx as no}from"react/jsx-runtime";var io=({children:e,isActive:t,onClick:i})=>no(J,{children:no(Ge,{onClick:i,className:t?"active":"",children:e})});import{Icon as ro,Row as ao,Text as Ht}from"@appcues/sonar";import{faChevronRight as zt}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{jsx as ee,jsxs as so}from"react/jsx-runtime";var lo=({icon:e,label:t})=>so(ao,{xAlign:"space-between",yAlign:"center",children:[so(ao,{spacing:"small",yAlign:"center",children:[ee(Y,{children:ee(ro,{icon:e,colorToken:"foreground-secondary",size:"small"})}),ee(Ht,{colorToken:"foreground-primary",forwardedAs:"span",children:t})]}),ee(ro,{icon:zt,colorToken:"foreground-secondary",size:"small"})]});import{forwardRef as Ut}from"react";import{Icon as Gt,NavigationMenu as _t}from"@appcues/sonar";import{jsx as R,jsxs as Vt}from"react/jsx-runtime";var po=Ut(({children:e,icon:t,iconElement:i,NavLink:n,to:a,end:s,isActive:r,external:c=!1,isSubItem:m,variant:d="regular",title:p,...h},v)=>{let k=c||!n?"a":n;return R(Q,{isSubItem:m,variant:d,className:"accordion-link-item",children:R(_t.Link,{asChild:!0,children:R(k,{ref:v,to:a,end:s,className:r?"active":"",...h,children:Vt(Ke,{fluid:!0,spacing:"small",yAlign:"center",children:[i&&i,t&&R(Y,{children:R(Gt,{icon:t,colorToken:"foreground-secondary",size:"small"})}),R(qe,{colorToken:"foreground-primary",title:p||"",children:e})]})})})})});import{NavigationMenu as Xt}from"@appcues/sonar";import Kt from"styled-components";import{Text as qt}from"@appcues/sonar";var co=Kt.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;
  border: 0;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${qt} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as mo}from"react/jsx-runtime";var go=({children:e,onClick:t,className:i})=>mo(Xt.Link,{asChild:!0,children:mo(co,{onClick:t,className:i,children:e})});var o={Wrapper:De,ScrollContainer:$e,NavList:He,Nav:Oe,NavItem:_e,NavButton:io,NavAccordion:to,NavTrigger:lo,LinkItem:po,ButtonItem:go};import{useEffect as he}from"react";function uo({user:e,account:t,cannyAppId:i,isOpen:n}){he(()=>{if(window.Canny&&t&&e){let{id:a,isTrial:s,tier:r,stripePlanId:c}=t,{fullname:m,email:d,id:p,job:h,crxVersion:v}=e;window.Canny("identify",{appID:i,user:{email:d,name:m||"anonymous",id:p,customFields:{job:h,crxVersion:v},companies:[{customFields:{isTrial:s,tier:r,stripePlanId:c},id:a,name:a}]}})}},[t,i,e]),he(()=>{!n&&window.Canny&&window.Canny("closeChangelog")},[n]),he(()=>{new MutationObserver(()=>{if(document.querySelector("[data-canny-changelog]"))try{window.Canny("initChangelog",{appID:i,position:"right",align:"bottom"})}catch(r){}}).observe(document.body,{childList:!0,subtree:!0})},[i])}import{Icon as nn,Row as rn,Tooltip as an}from"@appcues/sonar";import{faScrewdriverWrench as sn}from"@fortawesome/pro-solid-svg-icons/faScrewdriverWrench";import _ from"styled-components";import{Button as on,Stack as tn,NavigationMenu as No}from"@appcues/sonar";import{Progress as jt}from"@appcues/sonar";import en from"pluralize";import{differenceInDays as Yt}from"date-fns";var ke=(e,t)=>Yt(e,t),fo=e=>new Intl.DateTimeFormat(void 0,{year:"numeric",month:"short",day:"2-digit"}).format(e);var Ie=(e,t)=>!((e==null?void 0:e.stripePlanId)||(t==null?void 0:t.isExpired));import G from"styled-components";import{Skeleton as Jt}from"@studio/legacy-components";import{Button as Zt,Tooltip as Qt}from"@appcues/sonar";var vo=G.div`
  text-align: center;
  gap: 8px;
  padding: 16px 24px 0 24px;
  display: flex;
  flex-direction: column;

  ${Jt} {
    width: 140px;
    height: 40px;
    margin: 0 auto;
  }

  ${Zt} {
    --link-color: #ffffff;
    --link-text-decoration: none;
    --link-visited-color: #ffffff;
  }
`,ho=G.div`
  font-weight: 700;
  color: rgb(57, 68, 85);
  font-size: 14px;
`,ko=G.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  width: 100%;
`,Io=G.div`
  width: 180px;
  white-space: pre-wrap;
  font-size: 0.75rem;
`,bo=G(Qt)`
  width: 100%;
`;import{jsx as oe,jsxs as be}from"react/jsx-runtime";var Ne=({account:e={},trialStatus:t={},className:i,Link:n})=>{let{createdAt:a,expirationDate:s,isWebInstalled:r,lengthDays:c}=t;if(!Ie(e,t)||!a||!s)return null;let d=ke(new Date(s),new Date(a))+1,p=ke(new Date(s),new Date)+1,v=(d-p)/d,k=Math.round(v*100),y=p>7?"default":(p>3,"error"),b=be(Io,{children:["Trial expires on ",fo(new Date(s)),"."," ",r?"":`Install the Appcues SDK to extend your trial another ${c} days.`]});return be(vo,{className:i,children:[oe(bo,{placement:"right",content:b,children:be(ko,{children:[oe(ho,{children:`${p} ${en("day",p)} left in trial`}),oe(jt,{value:k,max:100,variant:y})]})}),oe(n,{to:"/subscription",children:"Upgrade now"})]})};var te=_(No.Trigger)`
  height: 40px;
`,xo=_(tn).attrs({spacing:"large"})`
  padding: var(--spacing-large);
`,yo=_(Ne)`
  padding: 0;
`,xe=_(on)`
  width: 100%;
  text-decoration: none;
`,E=_(No.Content)`
  position: absolute;
  transform: translateY(-40px);
  left: 100%;
  margin-left: var(--spacing-x-small);
  background-color: var(--color-neutral-0);
  border-radius: var(--border-radius-small);
  gap: var(--spacing-x-small);
  padding: var(--spacing-small) var(--spacing-x-small);
  box-shadow: var(--elevation-300);
  transform: translateY(-40px);
  width: 200px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;import{jsx as V,jsxs as Lo}from"react/jsx-runtime";var wo=({NavLink:e,isInstalled:t,account:i,trialStatus:n})=>Lo(xo,{children:[t?null:V(an,{size:"regular",content:"In order to publish live experiences to your users, you'll have to install Appcues directly into your codebase. Don't worry...it's super easy. Click here to learn how!",children:V(xe,{variant:"secondary",fluid:!0,forwardedAs:e,to:"/settings/installation",children:Lo(rn,{spacing:"small",yAlign:"center",children:[V(nn,{icon:sn}),"Install"]})})}),V(yo,{account:i,trialStatus:n,Link:a=>V(xe,{variant:"tertiary",forwardedAs:e,...a})})]});import{useState as Ro}from"react";import{faGear as mn}from"@fortawesome/pro-solid-svg-icons/faGear";import{faChevronRight as gn}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{faExternalLink as dn}from"@fortawesome/pro-solid-svg-icons/faExternalLink";import{faArrowRightFromBracket as un}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{Icon as ie,Row as Le,Stack as fn,Text as we,NavigationMenu as re}from"@appcues/sonar";import A from"styled-components";import{Text as Ao,Stack as ln,Row as pn}from"@appcues/sonar";import{Separator as cn}from"@radix-ui/react-separator";var So=A(ln).attrs({spacing:"x-small"})`
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,To=A(E)`
  transform: translateY(-105%);
  width: 237px;
`,Po=A(pn)`
  max-width: calc(100% - var(--spacing-large));
`,ne=A(Ao).attrs({colorToken:"foreground-primary",forwardedAs:"span",weight:"bold"})`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`,Co=A.div`
  display: flex;
  padding: var(--spacing-small) var(--spacing-regular);
  cursor: pointer;
`,Mo=A(Ao)`
  padding-left: 22px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`,ye=A(cn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
`;import{jsx as f,jsxs as w}from"react/jsx-runtime";var Eo=({NavLink:e,onLogout:t,user:{email:i,fullName:n}={},companyName:a,accountsCount:s})=>{let r=a||i||"",[c,m]=Ro(),[d,p]=Ro(!1),h=v=>{c&&!d&&(v.preventDefault(),p(!0)),c&&d&&p(!1)};return f(re.Root,{orientation:"vertical",value:c,onValueChange:v=>{m(v),v||p(!1)},children:f(re.List,{children:w(re.Item,{value:"account-menu",children:[f(re.Trigger,{onClick:h,children:w(So,{children:[w(Le,{xAlign:"space-between",yAlign:"center",children:[w(Po,{spacing:"small",yAlign:"center",children:[f(ie,{icon:mn,colorToken:"foreground-secondary",size:"small"}),f(ne,{title:r,children:r})]}),f(ie,{icon:gn,colorToken:"foreground-secondary",size:"small"})]}),n&&f(Mo,{title:n,size:"small",children:n})]})}),f(To,{children:w("ul",{children:[s>1?f(o.LinkItem,{isSubItem:!0,variant:"tall",NavLink:e,to:"/accounts-v2",children:w(fn,{spacing:"x-small",children:[f(ne,{title:r,children:r}),f(we,{size:"small",children:"Switch Accounts"})]})}):f(Co,{children:f(ne,{title:r,children:r})}),f(ye,{}),f(o.LinkItem,{isSubItem:!0,NavLink:e,to:"/settings/account",children:"Settings"}),f(o.LinkItem,{external:!0,isSubItem:!0,"data-canny-link":!0,href:"https://feedback.appcues.com/product-feedback?sort=top",target:"_blank",children:"Suggest a feature"}),f(o.LinkItem,{external:!0,isSubItem:!0,href:"https://status.appcues.com",target:"_blank",children:w(Le,{xAlign:"space-between",yAlign:"center",children:[f(we,{forwardedAs:"span",children:"Appcues status"}),f(ie,{icon:dn,colorToken:"foreground-link"})]})}),f(ye,{}),f("li",{children:f(o.ButtonItem,{onClick:t,children:w(Le,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[f(we,{colorToken:"foreground-primary",forwardedAs:"span",children:"Sign out"}),f(ie,{colorToken:"foreground-secondary",icon:un})]})})})]})})]})})})};import B from"styled-components";import{NavigationMenu as Bo,Row as vn}from"@appcues/sonar";import{Separator as hn}from"@radix-ui/react-separator";var F=B(hn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
  padding: 0.1px 0 0 0;
`,ae=B.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  height: 100%;
  overflow-y: auto;
`,Fo=B(Bo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  & ul {
    list-style-type: none;
  }
`,Wo=B(Bo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;

  & ul {
    list-style-type: none;
  }
`,K=B.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
`,Do=B(vn).attrs({spacing:"x-small",yAlign:"center",xAlign:"center"})`
  background: var(--color-neutral-100);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-x-small);
  color: var(--foreground-secondary);

  svg path {
    fill: var(--foreground-secondary) !important;
  }
`;import{useState as _o}from"react";import{NavigationMenu as pe}from"@appcues/sonar";import{faFolderMagnifyingGlass as Mn}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as Rn}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as En}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faUsers as Oo}from"@fortawesome/pro-solid-svg-icons/faUsers";import{faArrowsTurnToDots as kn}from"@fortawesome/pro-solid-svg-icons/faArrowsTurnToDots";import{faMessages as In}from"@fortawesome/pro-solid-svg-icons/faMessages";import{faMap as Ho}from"@fortawesome/pro-solid-svg-icons/faMap";import{faThumbtack as bn}from"@fortawesome/pro-solid-svg-icons/faThumbtack";import{faCheckCircle as Nn}from"@fortawesome/pro-solid-svg-icons/faCheckCircle";import{faComment as xn}from"@fortawesome/pro-solid-svg-icons/faComment";import{faRocket as yn}from"@fortawesome/pro-solid-svg-icons/faRocket";import{faChartColumn as zo}from"@fortawesome/pro-solid-svg-icons/faChartColumn";import{faBullseye as Ln}from"@fortawesome/pro-solid-svg-icons/faBullseye";import{faChartPieSimple as wn}from"@fortawesome/pro-solid-svg-icons/faChartPieSimple";import{faBuildings as An}from"@fortawesome/pro-solid-svg-icons/faBuildings";import{faTh as Sn}from"@fortawesome/pro-solid-svg-icons/faTh";import{faRectangleCode as Tn}from"@fortawesome/pro-solid-svg-icons/faRectangleCode";import{NavigationMenu as se}from"@appcues/sonar";import{faEnvelopeOpen as Pn}from"@fortawesome/pro-solid-svg-icons";import{jsx as $o}from"react/jsx-runtime";var W=()=>$o("svg",{width:"18",height:"16",viewBox:"0 0 18 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:$o("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17.1258 5L14.902 8.00085L17.1246 11H1.1258L3.34967 7.99915L1.12706 5H17.1258ZM0.874146 11H0.874181L0.874181 5H0.874146V11Z",fill:"var(--foreground-secondary)"})});import{Fragment as Cn,jsx as u,jsxs as S}from"react/jsx-runtime";var Uo={MESSAGING:[/^\/banners(\/.*)?$/,/^\/pins(\/.*)?$/,/^\/checklists(\/.*)?$/,/^\/nps(\/.*)?$/,/^\/nps-v2(\/.*)?$/,/^\/launchpads(\/.*)?$/,/^\/flows-v2(\/.*)?$/,/^\/embeds(\/.*)?$/],METRICS:[/^\/goals(\/.*)?$/,/^\/insights\/explorer(\/.*)?$/,/^\/insights\/charts(\/.*)?$/,/^\/email-performance(\/.*)?$/]},le=(e,t)=>t.some(i=>e.startsWith(i)),Go=(e,t)=>t.some(i=>i.test(e)),Ae=({NavLink:e,currentPath:t,featureFlags:i,handleClick:n})=>{let{hasLaunchpads:a,hasNps2:s,hasOpenBuilderFlows:r}=i,c=le(t,["/flows","/mobile","/experiments"]),m=Go(t,[...Uo.MESSAGING])||c,d=le(t,["/audience/segments","/segments"]),p=le(t,["/audience/users"]),h=le(t,["/audience"])||d||p,v=Go(t,[...Uo.METRICS]);return S(Cn,{children:[u(se.Item,{children:u(o.LinkItem,{icon:kn,NavLink:e,to:"/workflows",children:"Workflows"},"/workflows")}),S(se.Item,{value:"messaging-menu",children:[u(te,{className:m?"active":"",onClick:k=>n(k,"messaging-menu"),children:u(o.NavTrigger,{icon:In,label:"Messaging"})}),u(E,{children:S("ul",{children:[u(o.LinkItem,{icon:Ho,NavLink:e,to:"/flows",isSubItem:!0,isActive:c,children:"Flows"},"/flows"),r&&u(o.LinkItem,{icon:Ho,NavLink:e,to:"/flows-v2",isSubItem:!0,children:"Flows 2.0"},"/flows-v2"),u(o.LinkItem,{icon:Tn,NavLink:e,to:"/embeds",isSubItem:!0,children:"Embeds"},"/embeds"),u(o.LinkItem,{iconElement:u(W,{}),NavLink:e,to:"/banners",isSubItem:!0,children:"Banners"},"/banners"),u(o.LinkItem,{icon:bn,NavLink:e,to:"/pins",isSubItem:!0,children:"Pins"},"/pins"),u(o.LinkItem,{icon:Nn,NavLink:e,to:"/checklists",isSubItem:!0,children:"Checklists"},"/checklists"),u(o.LinkItem,{icon:xn,NavLink:e,to:s?"/nps-v2":"/nps",isSubItem:!0,children:"NPS"},"/nps"),a&&u(o.LinkItem,{icon:yn,NavLink:e,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]})})]}),S(se.Item,{value:"audiences-menu",children:[u(te,{className:h?"active":"",onClick:k=>n(k,"audiences-menu"),children:u(o.NavTrigger,{icon:Oo,label:"Audiences"})}),u(E,{children:S("ul",{children:[u(o.LinkItem,{icon:wn,NavLink:e,to:"/audience/segments-v2",isSubItem:!0,isActive:d,children:"Segments"},"/audience/segments-v2"),u(o.LinkItem,{icon:Oo,NavLink:e,to:"/audience/users-v2",isSubItem:!0,isActive:p,children:"Users"},"/audience/users-v2"),u(o.LinkItem,{icon:An,NavLink:e,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]})})]}),S(se.Item,{value:"metrics-menu",children:[u(te,{className:v?"active":"",onClick:k=>n(k,"metrics-menu"),children:u(o.NavTrigger,{icon:zo,label:"Metrics"})}),u(E,{children:S("ul",{children:[u(o.LinkItem,{icon:Ln,NavLink:e,to:"/goals",isSubItem:!0,children:"Goals"},"/goals"),u(o.LinkItem,{icon:zo,NavLink:e,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),u(o.LinkItem,{icon:Sn,NavLink:e,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),u(o.LinkItem,{icon:Pn,NavLink:e,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]})})]})]})};import{jsx as L,jsxs as Bn}from"react/jsx-runtime";function Se({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:a,actions:s,currentPath:r,hasLaunchpads:c,hasNps2:m,hasOpenBuilderFlows:d,hasDevTools:p}){let[h,v]=_o(),[k,y]=_o({}),b=(N,I)=>{h===I&&!k[I]&&(N.preventDefault(),y({[I]:!0})),h===I&&k[I]&&y({[I]:!1})},M=(N,I)=>{b(N,I)};return L(Fo,{orientation:"vertical",value:h,onValueChange:N=>{v(N),N||y({})},children:L(pe.List,{children:Bn(ae,{children:[e&&s?s:null,t&&!i?null:L(pe.Item,{children:L(o.LinkItem,{icon:Rn,NavLink:n,to:"/",end:a,children:"Overview"})}),L(K,{children:L(Ae,{NavLink:n,currentPath:r,handleClick:(N,I)=>M(N,I),featureFlags:{hasLaunchpads:c,hasNps2:m,hasOpenBuilderFlows:d}})}),L(F,{}),L(pe.Item,{children:L(o.LinkItem,{icon:Mn,NavLink:n,to:"/folders",children:"Folders"})}),p&&L(pe.Item,{children:L(o.LinkItem,{icon:En,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{Icon as Fn,NavigationMenu as Te,Row as Wn}from"@appcues/sonar";import{trackEvent as Dn}from"@studio/analytics";import{faArrowsTurnToDots as $n,faMessages as On,faMap as Vo,faThumbtack as Hn,faCheckCircle as zn,faComment as Un,faChartColumn as Ko,faBullseye as Gn,faEnvelopeOpen as _n,faTh as Vn,faUsers as qo,faChartPieSimple as Kn,faBuildings as qn,faRocket as Xn,faChartLine as Yn,faFlask as Jn,faRectangleCode as Zn,faLightbulb as Qn,faBarsFilter as jn}from"@fortawesome/pro-solid-svg-icons";import{faFolderMagnifyingGlass as ei}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as oi}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as ti}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faSparkles as ni}from"@fortawesome/pro-regular-svg-icons";import{jsx as l,jsxs as T}from"react/jsx-runtime";var ii=["/flows","/pins","/banners","/checklists","/nps","/embeds"],ri=["/goals","/insights/explorer","/insights/charts","/insights/funnels","/email-performance"],ai=["/audience/segments-v2","/audience/users-v2","/audience/accounts"];function Pe({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:a,actions:s,currentPath:r,hasNps2:c,hasOpenBuilderFlows:m,hasDevTools:d,hasAiInsights:p,hasFunnels:h}){let v=ii.some(b=>r.startsWith(b)),k=ri.some(b=>r.startsWith(b)),y=ai.some(b=>r.startsWith(b));return l(Wo,{orientation:"vertical",children:l(Te.List,{children:T(ae,{children:[e&&s?s:null,T(K,{children:[t&&!i?null:l(o.LinkItem,{icon:oi,NavLink:n,to:"/",end:a,children:"Overview"}),p&&l(o.LinkItem,{NavLink:n,to:"/insights-feed",icon:Qn,onClick:()=>{Dn({name:"nav_click",properties:{navItemID:"insights-feed",navItemName:"Insights"}})},children:T(Wn,{xAlign:"space-between",yAlign:"center",spacing:"small",children:["Insights",l(Do,{children:l(Fn,{icon:ni,size:"small"})})]})})]}),T(K,{children:[T(o.NavAccordion,{isActive:v,text:"Experiences",icon:On,children:[l(o.LinkItem,{NavLink:n,to:"/flows",icon:Vo,isSubItem:!0,children:"Flows"},"/flows"),m&&l(o.LinkItem,{icon:Vo,NavLink:n,to:"/flows-v2",isSubItem:!0,title:"Flows 2.0",children:"Flows 2.0"},"/flows-v2"),l(o.LinkItem,{icon:Zn,NavLink:n,to:"/embeds",isSubItem:!0,title:"Embeds",children:"Embeds"},"/embeds"),l(o.LinkItem,{NavLink:n,to:"/pins",icon:Hn,isSubItem:!0,children:"Pins"},"/pins"),l(o.LinkItem,{NavLink:n,to:"/banners",iconElement:l(W,{}),isSubItem:!0,children:"Banners"},"/banners"),l(o.LinkItem,{NavLink:n,to:"/checklists",icon:zn,isSubItem:!0,children:"Checklists"},"/checklists"),l(o.LinkItem,{NavLink:n,to:c?"/nps-v2":"/nps",icon:Un,isSubItem:!0,children:"NPS"},"/nps"),l(o.LinkItem,{icon:Xn,NavLink:n,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]}),T(o.NavAccordion,{isActive:k,text:"Metrics",icon:Ko,children:[l(o.LinkItem,{NavLink:n,to:"/goals",icon:Gn,isSubItem:!0,children:"Goals"},"/goals"),l(o.LinkItem,{icon:Ko,NavLink:n,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),l(o.LinkItem,{icon:Vn,NavLink:n,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),h&&l(o.LinkItem,{icon:jn,NavLink:n,to:"/insights/funnels",isSubItem:!0,children:"Funnels"},"/insights/funnels"),l(o.LinkItem,{NavLink:n,to:"/experiments",icon:Jn,isSubItem:!0,children:"Experiments"},"/experiments"),l(o.LinkItem,{NavLink:n,to:"/performance",icon:Yn,isSubItem:!0,children:"Flow Performance"},"/performance"),l(o.LinkItem,{title:"Email Performance",icon:_n,NavLink:n,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]}),T(o.NavAccordion,{isActive:y,text:"Audiences",icon:qo,children:[l(o.LinkItem,{icon:Kn,NavLink:n,to:"/audience/segments-v2",isSubItem:!0,children:"Segments"},"/audience/segments-v2"),l(o.LinkItem,{icon:qo,NavLink:n,to:"/audience/users-v2",isSubItem:!0,children:"Users"},"/audience/users-v2"),l(o.LinkItem,{icon:qn,NavLink:n,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]}),l(o.LinkItem,{NavLink:n,to:"/workflows",icon:$n,children:"Workflows"},"/workflows")]}),l(F,{}),l(Te.Item,{children:l(o.LinkItem,{icon:ei,NavLink:n,to:"/folders",children:"Folders"})}),d&&l(Te.Item,{children:l(o.LinkItem,{icon:ti,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{jsx as P,jsxs as si}from"react/jsx-runtime";var Xo=({user:e,account:t,accountsCount:i,onSpoof:n,onLogout:a,isSpoofing:s,NavLink:r,featureFlags:c,matchExactRoutes:m,isInstalled:d,trialStatus:p,cannyAppId:h,currentPath:v,actions:k})=>{let{hasDevTools:y,hasLaunchpads:b,hasOverviewRedirect:M,hasAiAssistant:N,hasNps2:I,hasOpenBuilderFlows:X,hasNav2025:ge,hasAiInsights:x,hasFunnels:ut}=c;return uo({user:e,account:t,cannyAppId:h,isOpen:!1}),si(o.Wrapper,{children:[P(D,{user:e,onSpoof:n,isSpoofing:s}),P(O,{size:"large"}),ge?P(Pe,{hasDevTools:y,hasOverviewRedirect:M,isInstalled:d,NavLink:r,matchExactRoutes:m,actions:k,currentPath:v,hasNps2:I,hasOpenBuilderFlows:X,hasAiAssistant:N,hasAiInsights:x,hasFunnels:ut}):P(Se,{hasDevTools:y,hasLaunchpads:b,hasOverviewRedirect:M,isInstalled:d,NavLink:r,matchExactRoutes:m,actions:k,currentPath:v,hasNps2:I,hasOpenBuilderFlows:X,hasAiAssistant:N}),P(wo,{NavLink:r,isInstalled:d,account:t,trialStatus:p}),P(F,{}),P(Eo,{user:e,companyName:t==null?void 0:t.name,NavLink:r,accountsCount:i,onLogout:a})]})};import{faCircleUser as vi}from"@fortawesome/pro-solid-svg-icons/faCircleUser";import{faPeopleGroup as hi}from"@fortawesome/pro-solid-svg-icons/faPeopleGroup";import{faCreditCard as ki}from"@fortawesome/pro-regular-svg-icons/faCreditCard";import{faLaptopMobile as Ii}from"@fortawesome/pro-solid-svg-icons/faLaptopMobile";import{faPaperPlane as bi}from"@fortawesome/pro-solid-svg-icons/faPaperPlane";import{faPlug as Ni}from"@fortawesome/pro-solid-svg-icons/faPlug";import{faDatabase as xi}from"@fortawesome/pro-solid-svg-icons/faDatabase";import{faGlobe as yi}from"@fortawesome/pro-solid-svg-icons/faGlobe";import{faSparkles as Li}from"@fortawesome/pro-solid-svg-icons/faSparkles";import{faArrowRightFromBracket as wi}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{faPalette as Ai}from"@fortawesome/pro-solid-svg-icons/faPalette";import{Icon as Si,NavigationMenu as jo,Row as Ti,Text as Pi}from"@appcues/sonar";import li from"styled-components";import{Button as pi,Icon as ci,Text as mi,Tooltip as gi}from"@appcues/sonar";import{faChevronLeft as di}from"@fortawesome/pro-solid-svg-icons/faChevronLeft";import{jsx as q}from"react/jsx-runtime";var ui=li.div`
  justify-self: end;
`,Yo=({onClick:e})=>q(ui,{children:q(gi,{content:q(mi,{size:"small",lineHeight:"large",colorToken:"foreground-tooltip",children:"Exit settings"}),placement:"bottom",children:q(pi,{title:"back link",variant:"tertiary",iconOnly:!0,onClick:e,children:q(ci,{icon:di})})})});import{Text as fi}from"@appcues/sonar";import Ce from"styled-components";var Jo=Ce(fi)`
  padding-left: var(--spacing-large);
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,Zo=Ce.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
`,Qo=Ce.div`
  padding-bottom: var(--spacing-small);
`;import{jsx as g,jsxs as C}from"react/jsx-runtime";var Ci=new Set(["/settings/integrations","/webhooks","/settings/keys","/integrations/webhooks","/integrations/connections"]),Mi=new Set(["/settings/events","/settings/properties","/settings/properties/users","/settings/properties/groups"]),Ri=["/settings/themes",/^\/themes(\/.*)?$/],Ei=["/settings/installation",/apps\/[^/]+$/],Bi=["/settings/emails/senders",/\/settings\/emails\/suppression-lists\/[^/]+$/],et=({NavLink:e,featureFlags:t,currentPath:i,user:n,onSpoof:a,isSpoofing:s,onClickBackArrow:r,onClickLogout:c,hasLocalizationAccess:m,actions:d})=>{let{hasIntegrationPageRedesign:p,hasMobileFlows:h,hasAIAssistant:v,hasSubscription:k}=t,y=Ci.has(i),b=Ri.some(x=>typeof x=="string"?x===i:x.test(i)),M=Mi.has(i),N=Ei.some(x=>typeof x=="string"?x===i:x.test(i)),I=Bi.some(x=>typeof x=="string"?x===i:x.test(i)),X=i.includes("/settings/emails/suppression-lists/"),ge=i.startsWith("/settings/properties");return C(o.Wrapper,{children:[g(D,{user:n,onSpoof:a,isSpoofing:s}),C(Zo,{children:[g(Yo,{onClick:r}),g(O,{})]}),g(jo.Root,{orientation:"vertical",children:g(jo.List,{children:v&&d?d:null})}),g(Jo,{size:"medium",weight:"semibold",children:"Settings"}),g(o.ScrollContainer,{children:g(o.Nav,{children:C(o.NavList,{children:[g(o.NavItem,{icon:vi,NavLink:e,to:"/settings/account",children:"Profile"}),g(o.NavItem,{icon:hi,NavLink:e,to:"/settings/team",children:"Team"}),k&&g(o.NavItem,{icon:ki,NavLink:e,to:"/settings/subscription",children:"Subscription"}),g(o.NavItem,{icon:Ii,NavLink:e,to:"/settings/installation",isActive:N,children:h?"Apps & Installation":"Installation"}),g(o.NavItem,{icon:Ai,NavLink:e,to:"/settings/themes",isActive:b,children:"Themes"}),v&&g(o.NavItem,{icon:Li,NavLink:e,to:"/settings/ai-assistant",children:"Appcues AI"}),C(o.NavAccordion,{text:"Emails",icon:bi,isActive:I,children:[g(o.NavItem,{NavLink:e,to:"/settings/emails/senders",children:"Senders"}),g(o.NavItem,{NavLink:e,to:"/settings/emails/suppression-lists/unsubscribes",isActive:X,children:"Suppression Lists"}),g(o.NavItem,{NavLink:e,to:"/settings/emails/sending-behavior",children:"Sending Behavior"})]}),C(o.NavAccordion,{text:"Integrations",icon:Ni,isActive:y,children:[g(o.NavItem,{NavLink:e,to:p?"/integrations/connections":"/settings/integrations",children:"Connections"}),g(o.NavItem,{NavLink:e,to:"/integrations/webhooks",children:"Webhooks"}),g(o.NavItem,{NavLink:e,to:"/settings/keys",children:"API Keys"})]}),C(o.NavAccordion,{text:"Data",icon:xi,isActive:M,children:[g(o.NavItem,{NavLink:e,to:"/settings/identifier",children:"Accounts & Users"}),g(o.NavItem,{NavLink:e,to:"/settings/events",children:"Events"}),g(o.NavItem,{NavLink:e,to:"/settings/properties/user",isActive:ge,children:"Properties"})]}),m&&g(o.NavItem,{icon:yi,NavLink:e,to:"/settings/localization",children:"Localization"})]})})}),g(o.NavList,{children:g(Qo,{children:g(o.NavButton,{onClick:c,children:C(Ti,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[g(Pi,{colorToken:"foreground-primary",children:"Sign out "}),g(Si,{colorToken:"foreground-secondary",size:"small",icon:wi})]})})})})]})};import Fi from"styled-components";var ot=Fi.div`
  flex: 0 0 220px;
  width: 220px;
  position: fixed;
  height: 100vh;
  background-color: var(--color-neutral-100);
  border-right: 1px solid var(--border-default);
  bottom: 0;
  left: 0;
  top: 0;
  z-index: 100;
`;import{jsx as Wi}from"react/jsx-runtime";var tt=()=>Wi(ot,{});import{useCallback as Di,useEffect as $i,useRef as Oi}from"react";import{createPopup as Hi}from"@typeform/embed";var zi={unmount:()=>{},open:()=>{}},Ui="QD5X3rU2";function nt({size:e=60,formValues:t={}}){let i=Oi(zi);return $i(()=>{let a={size:e,hidden:t};i.current=Hi(Ui,a)},[i,e,t]),{handleClick:Di(()=>i.current.open(),[i])}}import it from"styled-components";import{Link as Gi}from"@appcues/sonar";var rt=it.span`
  --font-size-regular: var(--font-size-small);
  --foreground-link: var(--color-blurple-400);
  --link-text-decoration: none;
`,at=it(Gi)``;import{jsx as st}from"react/jsx-runtime";var lt=({children:e,message:t,subject:i,user:n,mailto:a="support@appcues.com",...s})=>{let r=(n==null?void 0:n.fullName)||(n==null?void 0:n.fullname),{email:c}=n!=null?n:{},m=["Hi,",t,"Thanks!"].join(`

`),d={message:t,subject:i,text:m,mailto:a,...r&&{name:r},...c&&{email:c}},{handleClick:p}=nt({formValues:d});return st(rt,{onClick:p,children:st(at,{"data-testid":"typeform-beacon",icon:!1,...s,children:e})})};import{Text as Xi}from"@appcues/sonar";import _i from"styled-components";import{Link as pt}from"@appcues/sonar";import{Link as Vi}from"react-router-dom";import{jsx as ct}from"react/jsx-runtime";var Ki=({children:e,href:t,...i})=>t?ct(pt,{href:t,...i,children:e}):ct(pt,{forwardedAs:Vi,...i,children:e}),ce=_i(Ki)``;import me from"styled-components";var qi=me.div`
  align-items: center;
  background: white;
  box-shadow: var(--elevation-200);
  display: flex;
  height: 48px;
  justify-content: center;
`,rp=me.div`
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 9000;
  min-width: 870px;
`,mt=me(qi)`
  background: var(--color-pink-600);
  color: white;
  gap: var(--spacing-small);
`,gt=me.div``;import{jsx as Me,jsxs as dt}from"react/jsx-runtime";var Yi=()=>Me(ce,{colorToken:"white",href:"#",onClick:e=>{e.preventDefault()},children:"Stop spoofing"});function Ji({accountId:e,spoofing:t,onDespoof:i}){return t?dt(mt,{"aria-live":"polite",role:"alert",children:[dt(Xi,{weight:"bold",colorToken:"white",children:["Spoofing Account ",e]}),Me(gt,{onClick:i,children:Me(Yi,{})})]}):null}export{W as BannerIcon,lt as BeaconLink,tt as BlankNavigation,ce as Link,Xo as MainNavigation,o as Navigation,et as SettingsNavigation,Ji as SpoofBanner,Ie as isTrialAccount};
//# sourceMappingURL=index.mjs.map